import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import unpackResult from 'utils/work/unpackResult';
import httpStatusCodes from 'utils/http/httpStatusCodes';
import parseResult from 'utils/work/parseResult';
var downloadFromS3 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(taskName, signedUrl) {
    var response, unpackedResult, parsedResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(signedUrl);
          case 2:
            response = _context.sent;
            if (!(response.status === httpStatusCodes.NOT_FOUND || response.status === httpStatusCodes.FORBIDDEN)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", null);
          case 5:
            if (response.ok) {
              _context.next = 7;
              break;
            }
            throw new Error("Error ".concat(response.status, ": ").concat(response.text), {
              cause: response
            });
          case 7:
            _context.next = 9;
            return unpackResult(response, taskName);
          case 9:
            unpackedResult = _context.sent;
            parsedResult = parseResult(unpackedResult, taskName);
            return _context.abrupt("return", parsedResult);
          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function downloadFromS3(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export default downloadFromS3;